import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { _ } from 'underscore';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  showLogin = true;
  isVisible = false;
  isVisible1 = false;
  showcontactus = true;
  showfaqus = true;
  url = environment.api_url;

  showFaq = '';
  constructor(
    private ref: ChangeDetectorRef,
    private router: Router,
    private http: HttpClient
  ) {}
  ngOnInit() {
    this.showFaq = sessionStorage.getItem('showFaq');
    this.showcontactus = sessionStorage.getItem('contcusFlag') ? false : true;
    this.showfaqus = sessionStorage.getItem('faqFlag') ? false : true;
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = false;
      let questionnarieObj = sessionStorage.getItem('userResponse');
      let percentage = sessionStorage.getItem('percentage');
      if (questionnarieObj && user) {
        const body = new HttpParams()
          .append('questionnarieObj', questionnarieObj)
          .append('userObj', user)
          .append('percentage', percentage);
        this.http
          .post(this.url + '/saveQuestions', body)
          .subscribe((res: any) => {
            console.log(res);
          });
      }
    }
  }
  addClass($event) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close.svg';
    }
  }

  clearSession() {
    sessionStorage.clear();
  }

  contactus() {
    sessionStorage.setItem('contcusFlag', 'contact');
    this.showcontactus = false;
    this.showfaqus = true;
    sessionStorage.removeItem('faqFlag');
  }

  faqus() {
    sessionStorage.setItem('faqFlag', 'faq');
    sessionStorage.removeItem('contcusFlag');
    this.showfaqus = false;
    this.showcontactus = true;
  }

  logoutFun() {
    sessionStorage.clear();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  gotoProfile() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.hg_accountId) {
        this.router.navigate(['user-settings', result.hg_accountId]);
      } else {
        this.router.navigate(['user-settings', result._id]);
      }
    }
  }

  activeClick() {
    this.isVisible = false;
    console.log('activeClick..', this.isVisible);
  }
}
